import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProductCard } from "@/components/ProductCard";

export default function Wishlist() {
  const { ids } = useWishlist();
  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
    api.get("/brands").then((r) => setBrands(r.data)).catch(() => {});
  }, []);

  const saved = products.filter((p) => ids.includes(p.id));
  const brandName = (slug) => brands.find((b) => b.slug === slug)?.name || slug;

  return (
    <main data-testid="wishlist-page">
      <Navbar />
      <section className="pt-32 md:pt-40 pb-24 min-h-screen">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.5em] text-gold mb-4">Wishlist</p>
          <h1 className="font-serif font-medium text-4xl sm:text-5xl lg:text-6xl text-zinc-900 tracking-tight mb-6" data-testid="wishlist-heading">
            Saved for <em className="text-gold">later</em>
          </h1>
          <p className="text-zinc-500 mb-16">{saved.length} {saved.length === 1 ? "treasure" : "treasures"} kept aside.</p>
          {saved.length === 0 ? (
            <div className="text-center py-24" data-testid="wishlist-empty">
              <p className="font-serif italic text-3xl text-zinc-400">Nothing saved yet.</p>
              <Link to="/shop" className="inline-block mt-8 bg-gold text-white text-xs uppercase tracking-[0.3em] px-10 py-4 hover:bg-champagne transition-colors duration-300">
                Discover the Collection
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10" data-testid="wishlist-grid">
              {saved.map((p, i) => (
                <ProductCard key={p.id} product={p} brandName={brandName(p.brand_slug)} index={i} />
              ))}
            </div>
          )}
        </div>
      </section>
      <Footer brands={brands} />
    </main>
  );
}
